
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groups/[groupSlug]/threads",
      function () {
        return require("private-next-pages/groups/[groupSlug]/threads/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groups/[groupSlug]/threads"])
      });
    }
  